import { style } from '@primeuix/styles/overlaybadge';
import BaseStyle from '@primevue/core/base/style';

var classes = {
  root: 'p-overlaybadge'
};
var OverlayBadgeStyle = BaseStyle.extend({
  name: 'overlaybadge',
  style: style,
  classes: classes
});

export { OverlayBadgeStyle as default };
//# sourceMappingURL=index.mjs.map
